import { Typography } from '@prenuvo/halo-web';
import { Slot } from '@/types';
import { useAvailabilitySlot } from '@/hooks';

export const AvailabilitySlot = ({
  slot,
  index,
  onSlotClick,
}: {
  slot: Slot;
  index: number;
  onSlotClick: (slot: Slot, isActive: undefined | boolean) => void;
}) => {
  const { classNames, machineCount, time, isActive } = useAvailabilitySlot(slot);

  return (
    <div
      key={index}
      data-testid="slot-box"
      className={`${classNames} grid min-h-12 min-w-[107px] items-center px-2 py-2`}
      onClick={(event: any) => {
        event.stopPropagation();
        onSlotClick(slot, isActive);
      }}
    >
      <div className="text-sm font-semibold">{time}</div>
      {machineCount > 1 && (
        <Typography variant="paragraph-xs" className="text-xs text-neutral-700">
          {machineCount} spots available
        </Typography>
      )}
    </div>
  );
};
